import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_share.less'
import { getI18n } from 'client/i18n'
import StandardError from 'components/common/standard_error'
import CrossFadeTransition from 'components/common/transitions/cross_fade'
import { UNDER_REVIEW_ERROR, CIP_ELIGIBILITY_CODES } from 'shared/shared_consts'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import ShareCampaignTextarea from 'components/common/share_campaign_textarea'
import { HeadingText } from '@paypalcorp/pp-react'
import CampaignEligibility from 'components/common/campaign_eligibility'
import { dexterURL } from 'shared/campaign_url'

export const I18N_CONTEXT = 'components/pages/crowdfunding/pool_share'
const i18n = getI18n(I18N_CONTEXT)

class CrowdfundingShare extends React.Component {
  static propTypes = {
    onPublish: PropTypes.func.isRequired,
    operatingRemotely: PropTypes.bool,
    campaignId: PropTypes.string,
    poolUrl: PropTypes.string.isRequired,
    creationError: PropTypes.object,
    shareDescription: PropTypes.string,
  }

  campaignCreated = ({ campaignId }) => {
    return campaignId !== NEW_CAMPAIGN_ID
  }

  componentDidMount() {
    const { operatingRemotely, creationError } = this.props

    // Checking if the campaign has already been created so that we don't create it twice.
    // This can happen when going back from the share page to here.
    if (
      !operatingRemotely &&
      !creationError &&
      !this.campaignCreated(this.props)
    ) {
      this.props.onPublish()
    }
  }

  UNSAFE_componentWillReceiveProps = newProps => {
    if (this.campaignCreated(newProps) && !this.campaignCreated(this.props)) {
      sendEnsightenEvent('MoneyPoolFin')
    }
  }

  render() {
    let Component
    const { creationError } = this.props
    if (creationError) {
      if (creationError.error === UNDER_REVIEW_ERROR) {
        Component = (
          <StandardError
            key="review_error"
            iconType="error"
            title={i18n('review_error_title')}
            subtitle={i18n('review_error_subtitle')}
            backButton={true}
          />
        )
      } else if (CIP_ELIGIBILITY_CODES.hasOwnProperty(creationError.error)) {
        if (CIP_ELIGIBILITY_CODES[creationError.error] === 'NEED_MORE_DATA') {
          const returnUrl = '/pools/c/create-crowdfunding/basics'
          location.href = dexterURL(returnUrl)
          return
        } else {
          Component = (
            <CampaignEligibility
              CIPStatusCode={CIP_ELIGIBILITY_CODES[creationError.error]}
            />
          )
        }
      } else {
        Component = (
          <StandardError
            key="error"
            iconType="warning"
            title={i18n('error_title')}
            subtitle={i18n('error_subtitle')}
            onTryAgain={this.props.onPublish}
          />
        )
      }
    } else if (this.campaignCreated(this.props)) {
      Component = (
        <div>
          <div styleName="success" />
          <HeadingText size="md" styleName="title">
            {i18n('share_title')}
          </HeadingText>
          <div styleName="subtitle-wrapper">
            <div styleName="subtitle">{i18n('share_your_page')}</div>
            <div styleName="subtitle">{i18n('share_with_others')}</div>
          </div>
          <div styleName="textarea-wrapper">
            <ShareCampaignTextarea
              campaignId={this.props.campaignId}
              description={this.props.shareDescription}
              data-pa-click="share"
              data-nemo="share-pool"
            />
          </div>
          <a
            data-pa-click="goToPool"
            data-nemo="go-to-pool"
            href={this.props.poolUrl}
            className={'vx_btn vx_btn-block vx_btn-secondary'}
          >
            {i18n('see_my_story')}
          </a>
        </div>
      )
    } else {
      // assume operatingRemotely
      Component = (
        <div styleName="create-indicator-container" key="spinner">
          <div className="vx_spinner-large" styleName="create-indicator" />
          <div styleName="spinner-title">{i18n('creating')}</div>
        </div>
      )
    }

    return <CrossFadeTransition>{Component}</CrossFadeTransition>
  }
}

export default cssModules(CrowdfundingShare, styles)
